import { render, staticRenderFns } from "./PublicRequisitionForm.vue?vue&type=template&id=73bd0fda&scoped=true"
import script from "./PublicRequisitionForm.vue?vue&type=script&lang=js"
export * from "./PublicRequisitionForm.vue?vue&type=script&lang=js"
import style0 from "./PublicRequisitionForm.vue?vue&type=style&index=0&id=73bd0fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd0fda",
  null
  
)

export default component.exports